import { CARD_CLASS_MAP } from "./action-cards/index.js";
import { DUCK_CARD_TYPES } from "./constants/duckCardTypes.js"

// Utility to shuffle arrays safely
export function shuffleArray(array) {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
}

// Factory for the playable action cards
export function generateActionDeck() {
    let deck = [];
    let uniqueIdCounter = 1;

    for (const typeId in CARD_CLASS_MAP) {
        const CardClass = CARD_CLASS_MAP[typeId];

        for (let i = 0; i < CardClass.countInDeck; i++) {
            deck.push(new CardClass(`card_${uniqueIdCounter++}`));
        }
    }

    return shuffleArray(deck);
}

// Factory for the Duck/Water Cards (Cards in the Line of Fire)
export function generateDuckDeck(activeTeams) {
    let deck = [];
    let uniqueIdCounter = 1;

    for (const key in DUCK_CARD_TYPES) {
        const cardDef = DUCK_CARD_TYPES[key];
        const activeTeamObj = activeTeams.find(teamData => teamData.id === cardDef.team);

        // Only add the card if it's WATER, or if we successfully found the team object
        if (cardDef.type === "water" || activeTeamObj) {
            for (let i = 0; i < cardDef.countInDeck; i++) {
                deck.push({
                    uid: `target_${uniqueIdCounter++}`,
                    typeId: cardDef.id,
                    team: activeTeamObj || null,
                    isDuck: cardDef.type === "duck",
                });
            }
        }
    }

    return shuffleArray(deck);
}